export type ScopeKind = 'unit' | 'artifact'

/** The virtual section_key for single-document artifacts (one author, one through-line).
 *  Persisted in outline_json, requirement_section_links, section_assignments — do not change. */
export const DOCUMENT_SECTION_KEY = '__document__'

export interface Scope {
  kind: ScopeKind
  artifactId: string
  unitId?: string
}

export type ResolverIntent = 'continue_or_approve' | 'reject' | 'new_request' | 'unclear'

export type DecisionReasonCode =
  | 'continuation_autoresolved'
  | 'continuation_clarification_required'
  | 'resolver_unavailable_fallback'
  | 'pending_action_missing'
  | 'pending_action_scope_mismatch'
  | 'policy_scope_violation'
  | 'policy_capability_blocked'
  | 'precondition_required'
  | 'revision_conflict'
  | 'pending_proposal_executed'
  | 'conflict_refresh_and_retry_recommended'
  | 'apply_succeeded'
  | 'pending_action_already_consumed'

export type PendingActionType = 'draft_patch_apply' | 'plan_outline_confirm' | 'plan_execute'
